import Vue from "vue";
import moment from "moment";
import accounting from "accounting";

Vue.filter("number", function(value, decimal = 2) {
  return accounting.formatNumber(value, decimal);
});

Vue.filter("currency", function(value) {
  if (value >= 0) return accounting.formatMoney(value);
  else if (!value) return accounting.formatMoney(Math.abs(value)); //Marcó error con !!value
  else return accounting.formatMoney(0, "- $ ");
});

Vue.filter("uppercase", function(value) {
    return value.toUpperCase();
});

Vue.filter('date', function(value) {
    if (value) {
      return moment(String(value)).format('DD/MMM/YYYY HH:mm').toUpperCase()
      .replace(".", "");
    }
  });
Vue.filter("datetime", function(value) {
    return moment(value)
        .format("DD/MMM/YYYY")
        .toUpperCase()
        .replace(".", "");
});
Vue.filter("percent", function(value) {
    return accounting.formatNumber(value, 1) + " %";
});
Vue.filter('birthdate', function(value) {
    if (value) {
      return moment(String(value)).format('DD/MMM/YYYY').toUpperCase().replace(".", "");
    }
});
Vue.filter('daymonth', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MMM').replace("/", " de ").replace(".", " ");
  }
});